import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import './index.css'
import App from './App'
import StandaloneApp from './StandaloneApp'
import reportWebVitals from './reportWebVitals'

const history = createBrowserHistory()

const isStandalone = process.env.REACT_APP_STANDALONE === 'true'

ReactDOM.render(
  <React.StrictMode>
    {isStandalone ? <StandaloneApp /> : <App history={history} />}
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
